import { koComponent } from '../../ko-utils';
import * as siteConfig from '../../site-config/config';

class AnimationDescriptor {
    constructor(params) {
        this.root = params.rootElement;
        this.onChange = params.onChange;

        if (!this.root()) {
            this.root(new siteConfig.AnimationDescriptor());
        }

        if (this.root().type) {
            this.root().type.subscribe((val) => {
                if (this.onChange) this.onChange();
            });
        }

        this.animationTypes = [
            { name: 'Shake', type: 'shake' },
            { name: 'Rubber Band', type: 'rubberBand' },
            { name: 'Flash', type: 'flash' }
        ];
    }
}

export default koComponent('animation-descriptor', AnimationDescriptor);